import React from "react";
import { Cell, PieChart, Pie } from "recharts";

import { FillColor, SpecifyName } from "../../BigPicture";

import "../../../assets/stlyes/Dashboard/DashboardDemographics.scss";

const DashBoardPieCharts = (props) => {
  const { item, mainIndex, isBackGround } = props;
  let pieChartSize = mainIndex ? 160 : 120;
  let strokeColor = (mainIndex && isBackGround) ? "var(--white-color)" : (mainIndex === false ? "var(--white-color)" : "var(--pieChart-stroke-color)");
  // const RADIAN = Math.PI / 180;
  // const renderCustomizedLabel = ({
  //   cx,
  //   cy,
  //   midAngle,
  //   innerRadius,
  //   outerRadius,
  //   percent,
  //   index
  // }) => {
  //   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  //   const x = cx + radius * Math.cos(-midAngle * RADIAN);
  //   const y = cy + radius * Math.sin(-midAngle * RADIAN);
  //   const textAnchor = "start";

  //   return (
  //     <text key={index} x={x} y={y} fill="white" textAnchor={textAnchor} dominantBaseline="auto" style={{ fontSize: "11px" }} > {percent > 0 ? `${(percent * 100).toFixed(0)}%` : ""}</text>
  //   );
  // };

  const renderCustomTooltip = (pieChartsDetails) => {
    if (pieChartsDetails && pieChartsDetails.length > 0) {
      const total = pieChartsDetails.reduce((accumulator, entry) => accumulator + entry.value, 0);
      const tooltipContent = [
        ...pieChartsDetails.map((item, index) => (
          <p key={index} className="d-flex align-items-center">
            <div className="buttonStyle" style={{ background: FillColor(item.name) }}></div>&nbsp;<p className="pieLegendNames">{`${total !== 0 ? Math.round((item.value * 100) / total) : 0}%-${SpecifyName(item.name)} (${item.value})`}</p>
          </p>
        )),
      ];
      return tooltipContent;
    } else {
      return null;
    }
  };

  return (
    // <OverlayTrigger trigger="hover" placement="bottom" overlay={<Popover id="popover-basic" className="custom-tooltip" style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>{renderCustomTooltip(item)}</Popover>}>
    //   <div className="d-flex flex-column align-items-center dashBoardPieChartsMain">
    //     <PieChart width={104} height={104} >
    //       {item && <Pie data={item} cx="50%" cy="50%" dataKey="value" outerRadius={52} isAnimationActive={true} labelLine={false} >
    //         {item.map((entry, index) => (
    //           <Cell key={`cell-${index}`} fill={FillColor(entry.name)} strokeWidth={4} stroke="var(--pieChart-stroke-color)" />))}
    //       </Pie>}
    //     </PieChart>
    //     <div className="d-flex flex-column pieLegendMain">{renderCustomTooltip(item)}</div>
    //   </div>
    // </OverlayTrigger>
    <div className={!isBackGround ? "d-flex flex-column align-items-center dashBoardPieChartsMain" : "d-flex flex-row align-items-center dashBoardPieChartsMain"}>
      <PieChart width={pieChartSize} height={pieChartSize} >
        {item && <Pie data={item} cx="50%" cy="50%" dataKey="value" outerRadius={pieChartSize / 2} isAnimationActive={true} labelLine={false} style={{ outline: "none" }}>
          {item.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={FillColor(entry.name)} strokeWidth={4} stroke={strokeColor} />))}
        </Pie>}
      </PieChart>
      <div className="d-flex flex-column pieLegendMain">
        {/* {item.map((item, i) => {
            return (<div key={i} className="d-flex align-items-center">
              <div className="buttonStyle" style={{ backgroundColor: FillColor(item.name) }}></div><p className="pieLegendNames">{SpecifyName(item.name)}({item.value})</p></div>)
          })} */}
        {renderCustomTooltip(item)}
      </div>
    </div>
  )
}

export { DashBoardPieCharts }